import { Typography, styled } from '@mui/material';

const SmallText = styled(Typography)`
  width: 160px;
  font-size: 0.75rem;
  overflow-wrap: break-word;
  word-break: break-word;
  line-height: 1.2;
`;

export default SmallText;
